import styled from '@emotion/styled';
import Colors from '../theme/colors';

export const Text4 = styled.span`
  color: ${Colors.text_2};
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 133%;
  letter-spacing: -0.4px;

  @media print {
    font-size: 14px;
  }
`;
